/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = ProductionBOMRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ProductionBOMEditor extends _Ext.MFGTransBOMGridEditor<ProductionBOMRow> {



        protected getColumnsKey() { return "Production.ProductionBOM"; }
        protected getDialogType() { return ProductionBOMDialog; }
        protected getLocalTextPrefix() { return ProductionBOMRow.localTextPrefix; }
        protected form: ProductionBOMForm;

        private pendingChanges: Q.Dictionary<any> = {};
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = false;

            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }

        // #region Variables 
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = false;
        public TotalItems: number;
        public isUpdate: number;
        public canUpdate: number;
        public DismantlingType: number;


        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            //   this.slickGrid.setOptions({ forceFitColumns: true, showFooterRow: true });
        }

        private Master;

        public setdata(items: ProductionBOMRow[]) {
            this.view.setItems([], false);
            for (let Detail of items) {
                Detail[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(Detail);
            }
        }
        //protected getColumns() {

        //    var columns = super.getColumns();

        //    var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
        //    var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
        //    //To Add Delete Button on Item Row
        //    columns.unshift({
        //        field: 'Delete Row',
        //        name: '',
        //        format: ctx => '<a class="inline-action delete-row" title="delete">' +
        //            '<i class="fa fa-trash-o text-red"></i></a>',
        //        width: 24,
        //        minWidth: 24,
        //        maxWidth: 24
        //    });

        //    Q.first(columns, x => x.field === fld.Pieces).format = int;
        //    Q.first(columns, x => x.field === fld.Weight).format = wt;
        //    return columns;
        //}
        public cleardata() {

            this.view.setItems([], false);

        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();


                if (target.hasClass('delete-row')) {

                    //TODO: Validate for TransItemID in RefTransItemID in Stock
                    Q.confirm('Are you sure want to Delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);
                        this.element.trigger('dialogclose');

                    });

                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            this.view.refresh();

        }
        // #region Column Add -Remove

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            } else if (field === fld.Pieces) {
                value = Q.parseInteger(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }
            var issueddata: Stock.JobTransactionRow[];
            var partyId = (this.parentDialog as ProductionItemsDialog).partyId;
            Stock.JobTransactionService.CustomJobReceiptValues({ BagNo: item.BagNo, LedgerId: partyId, ProductId: item.BomProductId }, function (response) {
                return issueddata = response.Entities;
            }, { async: false });

            if (field === fld.Pieces && value > 0) {
                if (issueddata[0].Pieces < value) {
                    q.alert('', 'Pieces are greater than issued', true);
                    item[field] = issueddata[0].Pieces;
                    value = issueddata[0].Pieces;
                }
                if (item.CalcOnId == 3)
                    item.Weight = (item.Weight / item.Pieces) * value;
                if (item.ItemTypeId == 105) {
                    if (issueddata[0].Pieces != value || issueddata[0].Weight != item.Weight) {
                        Q.confirm('Do you want to keep remaining items with Supplier  ? ', () => {
                            item[field] = value;
                            if (issueddata[0].PointerWeight > 0)
                                item.Weight = value * issueddata[0].PointerWeight;
                            else
                                item.Weight = value * (issueddata[0].Weight / issueddata[0].Pieces);
                            this.view.updateItem(id, item);
                            this.view.refresh();
                        }, {
                            onNo: () => {
                                item[field] = value;
                                if (issueddata[0].PointerWeight > 0)
                                    item.Weight = value * issueddata[0].PointerWeight;
                                else
                                    item.Weight = value * (issueddata[0].Weight / issueddata[0].Pieces);
                                this.view.updateItem(id, item);
                                this.view.refresh();
                                (this.parentDialog as ProductionItemsDialog).SetMaterialInData(item, issueddata[0]);
                            }
                        });
                    }
                }
            }

            if (field === fld.Weight) {
                if (issueddata[0].Pieces == item.Pieces) {
                    q.alert('', 'Pieces need to be changed first', true);
                    item[field] = issueddata[0].Weight;
                    value = issueddata[0].Weight;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    return;
                }
                if (issueddata[0].Weight < value) {
                    q.alert('', 'Weight is greater than issued', true);
                    item[field] = issueddata[0].Weight;
                    value = issueddata[0].Weight;
                }
                if (item.CalcOnId != 3) {
                    if (item.ItemTypeId == 105) {
                        if (issueddata[0].Pieces > item.Pieces && issueddata[0].Weight == value) {
                            q.alert('', 'Weight is greater than issued', true);
                            if (issueddata[0].PointerWeight > 0)
                                item[field] = item.Pieces * issueddata[0].PointerWeight;
                            else

                                item[field] = (issueddata[0].Weight / issueddata[0].Pieces) * item.Pieces;
                            this.view.updateItem(id, item);
                            this.view.refresh();

                        }



                    }
                    item[field] = value;
                }
            }


            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }
        protected getButtons() {
            var btns = super.getButtons();
            btns.pop();
            return btns;
        }
        
        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


    }
}